import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import * as model from "../../../models";
import { Store } from "@ngrx/store";
import { AppState } from "../../../reducers";
import { MessageActions } from "../../../actions";
import { EventApi } from "../../../services/webservice";

@Component({
	selector: 'cost-center',
	template: `
			<cost-center-presentation
				[costCenter]="event?.costCenter"
				(saveCostCenter)="updateEvent($event)">
			</cost-center-presentation>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class CostCenterComponent {
	@Input() private event: model.Event;
	@Output() private eventChange = new EventEmitter<model.Event>();

	constructor(
		private eventApi: EventApi,
		private store: Store<AppState>,
		private messageActions: MessageActions) { }

	private updateEvent(costCenter: string) {
		this.eventApi.patchEventSpecificProperties(this.event.storageId, {costCenter: costCenter}).subscribe(
			event => {
				this.eventChange.emit(event);
				this.store.dispatch(this.messageActions.displayMessage("Die Kostenstelle wurde erfolgreich geändert.", "success"));
			},
			error => {
				this.handleError(error);
			}
		)
	}

	private handleError(error: any) {
		if (!error.messageDe) {
			error.messageDe = "Es ist ein unerwarteter Fehler aufgetreten.";
		}
		this.store.dispatch(this.messageActions.displayMessage(error.messageDe, "error"));
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/cost-center/cost-center.component.ts